import React from 'react'
import { ListHeader } from '@labsavvyapp/ui-components'
import style from '../../OrdersetList.module.css'

export const OrdersetListHeader = () => {
  return (
    <ListHeader
      className={style.header}
      columns={[
        {
          name: 'Orderset Name',
          className: style.column,
        },
        {
          name: '',
          className: style.column,
        },
        {
          name: 'Orderset Client Bill',
          className: style.column,
        },
        {
          name: 'Orderset Patient Bill',
          className: style.column,
        },
      ]}
    />
  )
}
